import React from "react";
import { Form, FormikProvider, useFormik } from "formik";

import useFarms from "../../../hooks/use-farms";
import { CustomButton, CustomDialog, FeaturedIcon } from "../../../components";

import css from "../../accounts/modals/modal-account.module.css";
import * as Yup from "yup";
import { useMutation } from "../../../hooks/use-mutation";
import RebatesClient from "../../../RebatesClient";
import { useNavigate } from "react-router-dom";
const ModalFarmRemove = ({
  open,
  onClose,
  account
}) => {
const navigate = useNavigate();

    const validationSchema = Yup.object({
    });

      const { mutateAsync: submitRequest, isLoading, } = useMutation({
        mutationKey: "removeFarm",
        networkMode: "always",
        mutationFn: async () => await RebatesClient.deleteAccount(account.id),
        onError: (err)=> {console.log(err)},
        onSuccess: (resp) => {
          if(resp.response.status == 200){
            navigate(`/account/${encodeURIComponent(account?.parent_account?.name)}`,{replace: true});
          }
          else {
            alert(`${resp.body.status}`)
          }
    
        }
      });
    

  const formik = useFormik({
    initialValues: {},
    validationSchema: validationSchema,
    onSubmit: submitRequest
  });

  const title = (
    <div className={css.modalTitle}>
      <FeaturedIcon icon="Trash" />
      Remove Farm
    </div>
  );

  return (
      <CustomDialog open={open} onClose={onClose} width={640} title={title}>
        <FormikProvider value={formik}>
          <Form className={css.modalForm}>
            <div className={css.formContent}>
              <div className={css.formGroup}>
                <p>Are you sure you want to remove <strong>{account?.name}</strong>?</p>
              </div>
            </div>

            <div className={css.actions}>
              <CustomButton
                label="Remove"
                type="submit"
                color="danger"
              />
            </div>
          </Form>
        </FormikProvider>
      </CustomDialog>
  );
}

export default ModalFarmRemove;
